import React, {useMemo} from 'react'
import styled from 'styled-components'
import {
  GIFT_SHOP_NOT_LINK_BASED_SOCIAL_MEDIA,
  WINDOW_MODE_TABLET_WIDTH,
} from 'consts'
import {useTranslation} from 'i18n'
import {getBorder, transformSocialType} from 'utils'
import {Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftshopEditProfileSocialContentItemProps} from './GiftShopEditProfileContentItemProps'

const StyledContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: ${convertUnit(10)};
  border-radius: ${convertUnit(8)};
  border: ${({theme}) => getBorder(1, 'solid', theme.gray_1)};
  flex-direction: column;
  width: 49%;
  word-break: break-all;
  margin: 0.5%;
  justify-content: space-between;
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    width: 100%;
  }
`

const StyledLinkContainer = styled.div`
  display: flex;
  align-self: flex-end;
`

const StyledSpan = styled.span`
  color: ${({theme}) => theme.info_5};
  cursor: pointer;
`

export default function GiftshopProfileSocialContentItem({
  item,
  onClickItem,
  onClickLinkItem,
}: GiftshopEditProfileSocialContentItemProps) {
  const {translate} = useTranslation()
  const socialValue = useMemo(
    () =>
      GIFT_SHOP_NOT_LINK_BASED_SOCIAL_MEDIA.includes(item.social_type)
        ? item.social_value.substring(item.social_value.lastIndexOf('/') + 1)
        : item.social_value,
    [item.social_type, item.social_value],
  )

  return (
    <StyledContainer>
      <Paragraph fontSize="m" fontWeight="medium">
        {transformSocialType(item.social_type)}:{' '}
        <StyledSpan onClick={() => onClickLinkItem(item.social_value)}>
          {socialValue}
        </StyledSpan>
      </Paragraph>
      <StyledLinkContainer>
        <Paragraph
          fontWeight="medium"
          color="primary_5"
          style={{cursor: 'pointer'}}
          onClick={() => onClickItem(item)}>
          {translate('giftShop:socialLink', {context: 'edit'})}
        </Paragraph>
      </StyledLinkContainer>
    </StyledContainer>
  )
}
